export type PipResizeCorner =
	| "top-left"
	| "top-right"
	| "bottom-left"
	| "bottom-right";

export interface PipResizeConfig {
	/** Minimum scale relative to the captured base size (1 = 100%). */
	minScale: number;
	/** Maximum scale relative to the captured base size. */
	maxScale: number;
	/** Scale snap targets, e.g. `[1, 1.25, 1.5]`. */
	snapScales: readonly number[];
	/** Snap when within this scale delta of a target. */
	snapThresholdScale: number;
	snapTransitionMs: number;
	/** Corner hit target size in px. */
	cornerHitSizePx: number;
}

export const DEFAULT_PIP_RESIZE_CONFIG: PipResizeConfig = {
	minScale: 1,
	maxScale: 1.5,
	snapScales: [1, 1.25, 1.5],
	snapThresholdScale: 0.06,
	snapTransitionMs: 280,
	cornerHitSizePx: 14,
};

export function resolvePipResizeConfig(
	partial?: Partial<PipResizeConfig>,
): PipResizeConfig {
	return {
		...DEFAULT_PIP_RESIZE_CONFIG,
		...partial,
	};
}

export function resolvePipResizeConfigFromProp(
	resize?: PipResizeConfig | boolean,
): PipResizeConfig | null {
	if (resize == null || resize === false) {
		return null;
	}
	if (resize === true) {
		return DEFAULT_PIP_RESIZE_CONFIG;
	}
	return resize;
}
